/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ModifyGradeBatchItemViewModel } from "../types/ModifyGradeBatchItemViewModel.ts";

export const modifyGradeBatchItemViewModelSchema = z.object({
  personId: z.optional(z.number().int()),
  grade: z.number().nullish(),
}) as unknown as ToZod<ModifyGradeBatchItemViewModel>;
